import actions from '@/core/store/ata/documentos-ata/processo-digital/actions'
import desentranhamento from '@/core/store/ata/documentos-ata/processo-digital/desentranhamento'

export default {
	actions,
	modules: {
		desentranhamento,
	},
}
